/**
 * The answer's action buttons, as the design draws them.
 *
 * Square, bordered, icon-only, all the same size. Shared from one constant because the row mixes
 * three components — copy, read-aloud, rating — and a row where one button is two pixels taller
 * than its neighbours is the kind of thing nobody files and everybody sees.
 *
 * Icon-only means the accessible name has to come from somewhere: every caller passes a `title`
 * *and* an `sr-only` label, because a title alone is not announced by every screen reader and is
 * invisible to a touch user.
 */
export const ACTION_BUTTON =
  "flex h-9 w-9 shrink-0 items-center justify-center rounded-xl border " +
  "border-borderStrong bg-surfaceRaised text-textMuted transition-all " +
  "hover:bg-primarySubtle hover:text-primary disabled:cursor-not-allowed " +
  "disabled:text-onPrimaryMuted";
